// extracted by mini-css-extract-plugin
module.exports = {"breakpoints":"\"~web/react/components/common/styles/breakpoints.css\"","small":"only screen and (min-width: 576px)","productCard":"_1-WGA"};